export default __webpack_public_path__ + "static/media/main-logo.db600d18.svg";